(ns common.phone-util)

(defn valid-phone-number-str?
  [phone-str]
  (re-matches #"^[\+][(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$" phone-str))
